import Vue from 'vue';
import VueRouter from 'vue-router';
import { TokenService } from '@/services/storage.service';
import store from '@/store/store';
import routes from './routes';

Vue.use(VueRouter);

/**
 * Configuración del Router
 *
 * MODE
 * Utilizamos el HTML5 history API para evitar tener rutas con hashes
 * Esta opción requiere modificar algunos parámetros en el servidor:
 * https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
 *
 * SCROLLBEHAVIOR
 * Simula el comportamiento nativo cuando navegamos a nueva ruta y volvemos a la anterior
 * con el botón de volver atrás, y la posición del scroll de la página se mantiene donde
 * nos habíamos quedado.
 */
const router = new VueRouter({
  routes,
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    // if (savedPosition) return savedPosition;
    return { x: 0, y: 0 };
  },
});

/**
 * Configuración previa a navegar a una nueva página
 */
// eslint-disable-next-line
router.beforeEach((routeTo, routeFrom, next) => {
  // Comprobamos:
  //   - Si la ruta requiere autenticación
  //   - Si la ruta es accesible cuando el usuario está logueado
  //   - Si el usuario está logueado
  const isPrivate = routeTo.matched.some(route => route.meta.private);
  const onlyWhenLoggedOut = routeTo.matched.some(record => record.meta.onlyWhenLoggedOut);
  const isLogged = !!TokenService.getToken() || store.getters['globalModule/isDemo'];

  // Si la ruta es privada y el usuario no está logueado lo redirigimos al login
  // y almacenamos la ruta para redireccionar al usuario después de hacer login
  if (isPrivate && !isLogged) {
    return next({
      name: 'login',
      query: { reaseon: 'notPermission', redirect: routeTo.fullPath },
    });
  }

  // No permitimos al usuario visitar ciertas páginas mientras está logueado
  if (isLogged && onlyWhenLoggedOut) {
    return next('/');
  }

  return next();
});

export default router;
